import { appConfig } from '../config/environment';
import { CookieHelper } from './cookieHelper';

/**
 * Checks if user is authenticated via session cookie
 * Returns custom token if authenticated, null if not
 * @param sessionCookie - The session cookie value to authenticate
 */
export const createAuthFromCookie = async (sessionCookie: string): Promise<string | null> => {
    try {
        const response = await fetch(`${appConfig.membershipApiBaseUrl}/getAuthFromSessionCookie`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                sessionCookie: sessionCookie
            })
        });

        if (response.ok) {
            const { customToken } = await response.json();
            
            if (!customToken) {
                throw new Error('No custom token received from API');
            }

            return customToken;
        } else {
            throw new Error(`API request failed: ${response.status} ${response.statusText}`);
        }
    } catch (error) {
        console.error('Failed to check session auth:', error);
    }
    return null;
};

/**
 * Clears session cookie from the domain specified in the environment configuration
 */
export const clearSessionCookie = (): void => {
    CookieHelper.clearCookie(appConfig.sessionCookieName, '/', 'None', true, appConfig.sessionCookieDomain);
};
